export enum Holiday {
    Anniversary,
    Brewfest,
    ChildrensWeek,
    DarkmoonFaire,
    DarkspearDash,
    DayOfTheDead,
    FreeTshirtDay,
    GreatGnomereganRun,
    HallowsEnd,
    LoveIsInTheAir,
    LunarFestival,
    MidsummerFireFestival,
    Noblegarden,
    PilgrimsBounty,
    PiratesDay,
    TrialOfStyle,
    WinterVeil,

    BonusArenaSkirmish,
    BonusBattleground,
    BonusDelve,
    BonusDungeon,
    BonusPetBattle,
    BonusWorldQuest,

    TimewalkingClassic,
    TimewalkingTbc,
    TimewalkingWotlk,
    TimewalkingCata,
    TimewalkingMop,
    TimewalkingWod,
    TimewalkingLegion,
    TimewalkingBfa,
    TimewalkingSl,
    TimewalkingDf,

    BrawlArathiBlizzard,
    BrawlClassicAshran,
    BrawlCompStomp,
    BrawlCookingImpossible,
    BrawlDeepSix,
    BrawlDeepwindDunk,
    BrawlGravityLapse,
    BrawlPackedHouse,
    BrawlShadoPanShowdown,
    BrawlSouthshoreVsTarrenMill,
    BrawlTempleOfHotmogu,
    BrawlWarsongScramble,

    CupEasternKingdoms, // Classic
    CupKalimdor, // Classic
    CupOutland, // TBC
    CupNorthrend, // WotLK
    CupPandaria, // MoP
    CupBrokenIsles, // Legion

    // Legion Emissaries
    EmissaryCourtFarondis,
    EmissaryDreamweavers,
    EmissaryHighmountainTribes,
    EmissaryNightfallen,
    EmissaryValarjar,
    EmissaryWardens,
    EmissaryArmiesLegionfall,
    EmissaryArgussianReach,
    EmissaryArmyLight,

    // Battle for Azeroth Emissaries
    EmissaryChampionsAzeroth,
    EmissaryTortollans,
    EmissaryProudmooreZandalari,
    EmissaryEmbersVoldunai,
    EmissaryStormsTalanjis,
    EmissaryLegionHonorbound,
    EmissaryWavebladeUnshackled,

    // Shadowlands Callings
    CallingAnimaSalvage,
    CallingRareResources,
    CallingStormTheMaw,
    CallingAidingArdenweald,
    CallingAidingBastion,
    CallingAidingMaldraxxus,
    CallingAidingRevendreth,
    CallingCallArdenweald,
    CallingCallBastion,
    CallingCallMaldraxxus,
    CallingCallRevendreth,
    CallingChallengesArdenweald,
    CallingChallengesBastion,
    CallingChallengesMaldraxxus,
    CallingChallengesRevendreth,
    CallingTrainingArdenweald,
    CallingTrainingBastion,
    CallingTrainingMaldraxxus,
    CallingTrainingRevendreth,

    // Temporary
    PrepatchMidnight,
}

export const timewalkingHolidays = [
    Holiday.TimewalkingClassic,
    Holiday.TimewalkingTbc,
    Holiday.TimewalkingWotlk,
    Holiday.TimewalkingCata,
    Holiday.TimewalkingMop,
    Holiday.TimewalkingWod,
    Holiday.TimewalkingLegion,
    Holiday.TimewalkingBfa,
    Holiday.TimewalkingSl,
    Holiday.TimewalkingDf,
];
